const B2B_ORGANIZATION_ASSIGNED_TYPES = {
    ALL_CATALOG: 1,
    ONLY_PANEL: 2
};
export { B2B_ORGANIZATION_ASSIGNED_TYPES };
